import React from 'react';
import Button from "@mui/material/Button";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const QualityModeButton = ({ enhanced3DQuality, onToggle }) => (
  <Button
    className={"ui-button2 ui-button2--medium ui-button2--primary-border"}
    style={{ backgroundColor: "white" }}
    startIcon={<LightbulbIcon />}
    onClick={onToggle}
    title="Switch lighting variant"
  >
    {enhanced3DQuality ? "Variant 2" : "Variant 1"}
  </Button>
);

export default QualityModeButton;
